export const getDateBeforeNDays = (days: number) => {
    // 获取当前日期和时间
    const currentDate = new Date();

    // 计算N天前的时间戳
    const timestampBeforeNDays = currentDate.getTime() - days * 24 * 60 * 60 * 1000;

    // 创建N天前的日期对象
    const dateBeforeNDays = new Date(timestampBeforeNDays);

    return dateBeforeNDays;
};

export const getDaysFromTwoDate = (date1: Date, date2: Date, systemTimeDate: Date) => {
    const result = [];

    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);
    // 确保date1早于date2
    if (date1 > date2) {
        const temp = date1;
        date1 = date2;
        date2 = temp;
    }

    // 创建一个临时日期变量，从date1开始
    const currentDate = new Date(date1);
    const today = new Date(systemTimeDate);
    today.setHours(0, 0, 0, 0); // 将今天的时间部分归零

    // 循环直到当前日期超过date2
    while (currentDate <= date2) {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1; // getMonth()返回值为0-11，所以要加1
        const day = currentDate.getDate();
        let week = currentDate.getDay();
        if (week === 0) {
            week = 7; //周日的day是0,转成7
        }
        let todayStatus = 'today'; // today

        if (currentDate < today) {
            todayStatus = 'before'; // before today
        } else if (currentDate > today) {
            todayStatus = 'after'; // after today
        }
        const dateString = getFullDate(year, month, day);

        result.push({ year: year, month: month, day: day, today: todayStatus, dateString: dateString, week: week });

        // 日期加1天
        currentDate.setDate(currentDate.getDate() + 1);
    }

    return result;
};

// 设置是否允许打卡日
export const setItemsIsLimit = (items: any[], data1: any) => {
    const limitTime = data1.limitTime || '';
    const reissueSign = data1.reissueSign; // 是否允许补卡
    const rewardByDayRespVos = data1.rewardByDayRespVos; // 会员后台配置的素材

    console.log({ rewardByDayRespVos });
    items.forEach((item: any, ind: number) => {
        const signInType = item.signInType;
        item.rewardByDayRespVos = (rewardByDayRespVos && rewardByDayRespVos[ind]) || {};
        item.signInPictureShow = data1.signInPictureShow;
        item.signInPictureUrl = data1.signInPictureUrl;
        item.points = data1.points;

        // 是否限制打卡
        if (!limitTime || limitTime.includes(item.week)) {
            item.isLimit = false;
        } else {
            item.isLimit = true;
        }
        // 允许补卡
        if (!signInType && item.today === 'before' && reissueSign) {
            item.reissueSign = true;
        }
    });
    return items;
};

// 从 items 获取当前 index 的 item
export const getItemFromItems = (items: any[], index: number | 'today') => {
    if (index === 'today') {
        const findIndex = items.findIndex((item2: any) => {
            return item2.today === index;
        });
        return items[findIndex];
    }
    return items[index];
};

// 将2004,8,1转成2004-08-01
export const getFullDate = (year: number, month: number, day: number) => {
    const month2 = `00${month}`.slice(-2);
    const day2 = `00${day}`.slice(-2);
    return `${year}-${month2}-${day2}`;
};

// 与后端协定,根据不同的返回值切换不同的提示语
export const getTipsMessageHandle = (res: any, TextA: any, locale: string) => {
    const { code, data } = res;
    // 成功
    if (code === '0') {
        const {
            durationSignInPoints,
            durationSignInDay,
            anySignInPoints,
            anySignInDay,
            normalSignInPoints,
            isOverLimit,
            isReissue,
            isCoupon,
            couponName,
            gainCouponRemainDay,
            rewardType,
            signedIn,
            gainPointsRemainDay,
            expectGainPoints,
            mixCouponIsOverLimit,
            mixPointsIsOverLimit,
        } = data;
        const tips: string[] = [];
        // 你已连续打卡a天，恭喜你获得X积分。
        if (durationSignInDay > 0 && durationSignInPoints > 0) {
            tips.push(`${TextA['successLongA1']}${durationSignInDay}${TextA['successLongA2']}${durationSignInPoints}${TextA['successLongA3']}`);
        }
        // 你已打卡a天，恭喜你获得X积分。
        if (anySignInDay > 0 && anySignInPoints > 0) {
            tips.push(`${TextA['successLongB1']}${anySignInDay}${TextA['successLongB2']}${anySignInPoints}${TextA['successLongA3']}`);
        }
        // 补签成功，恭喜你获得XX积分。
        if (isReissue && normalSignInPoints > 0) {
            tips.push(`${TextA['successSortA1']}${normalSignInPoints}${TextA['successLongA3']}`);
        }
        // 签到成功，恭喜你获得XX积分。
        if (!isReissue && normalSignInPoints > 0) {
            tips.push(`${TextA['successSortB1']}${normalSignInPoints}${TextA['successLongA3']}`);
        }

        // 你已达可获取的积分上限值，感谢你的参与。
        if (isOverLimit && tips.length === 0) {
            if (rewardType === 1) {
                tips.push(TextA['successLongC2']);
            } else if (rewardType === 2) {
                tips.push(TextA['successLongC3']);
            }
        }

        // 你已达可获取的积分上限值，感谢你的参与。
        // if (isOverLimit && tips.length === 0) {
        //     tips.push(TextA['successLongC2']);
        // }
        // 恭喜你获得【XX】优惠券。
        if (isCoupon) {
            tips.push(`${TextA['couponTipsC1']}${couponName}${TextA['couponTipsC2']}`);
        }
        // 签到成功，再签到X天，就能获XX积分了
        if (signedIn && gainPointsRemainDay && expectGainPoints) {
            const isReplacePosition = ['jp', 'kr'].includes(locale); // 是否调换X与XX的位置
            const textAL = !isReplacePosition ? gainPointsRemainDay : expectGainPoints;
            const textAR = !isReplacePosition ? expectGainPoints : gainPointsRemainDay;
            tips.push(`${TextA['pointTipsA1']}${textAL}${TextA['pointTipsA2']}${textAR}${TextA['pointTipsA3']}`);
        }
        // 补签成功！再签到X天，就能获【XX】优惠券了。
        if (isReissue && gainCouponRemainDay && rewardType === 2) {
            const isReplacePosition = ['jp', 'kr'].includes(locale); // 是否调换X与XX的位置
            const textAL = !isReplacePosition ? gainCouponRemainDay : couponName;
            const textAR = !isReplacePosition ? couponName : gainCouponRemainDay;
            tips.push(`${TextA['couponTipsB1']}${textAL}${TextA['couponTipsB2']}${textAR}${TextA['couponTipsB3']}`);
        }
        // 签到成功！再签到X天，就能获【XX】优惠券了。
        if (!isReissue && gainCouponRemainDay && rewardType === 2) {
            const isReplacePosition = ['jp', 'kr'].includes(locale); // 是否调换X与XX的位置
            const textAL = !isReplacePosition ? gainCouponRemainDay : couponName;
            const textAR = !isReplacePosition ? couponName : gainCouponRemainDay;
            tips.push(`${TextA['couponTipsA1']}${textAL}${TextA['couponTipsA2']}${textAR}${TextA['couponTipsA3']}`);
        }

        // 混合奖励的提示语
        if (rewardType === 3) {
            // 超出积分上限
            if (mixPointsIsOverLimit) {
                tips.push(TextA['successLongC2']);
            }
            // 超出优惠券上限
            if (mixCouponIsOverLimit) {
                tips.push(TextA['successLongC3']);
            }
        }
        // 签到成功。
        if (!isReissue && normalSignInPoints === 0 && anySignInPoints === 0 && durationSignInPoints === 0 && tips.length === 0) {
            tips.push(TextA['successSortC']);
        }

        return tips.join('\n');
    }
    // 失败
    if (code === '2452') {
        return TextA['code2452'];
    } else if (code === '2453') {
        return TextA['code2453'];
    } else if (code === '2454') {
        return TextA['code2454'];
    } else if (code === '2455') {
        return TextA['code2455'];
    } else if (code === '2457') {
        return TextA['code2457'];
    } else if (code === '2466') {
        return TextA['code2466'];
    } else if (code !== '0') {
        // 其它失败情况
        return TextA['codeFail'];
    }
    return null;
};

// 滚动到指定位置
export const scrollXToElement = (container: any, target: any) => {
    if (container && target) {
        const targetOffsetLeft = target.offsetLeft - container.offsetLeft;
        console.log('scrollXToElement', container, target, targetOffsetLeft);
        container.scrollTo({
            left: targetOffsetLeft,
            behavior: 'smooth',
        });
    }
};
